import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ConsultarTermoFidelidade,
  ContratoResponse,
  ContratoVolume
} from 'src/models/interfaces/contrato/contrato.interface';
import { HeadersService } from '../header.service';
@Injectable({
  providedIn: 'root'
})
export class ContratoService {
  private readonly contratosUrl = `${environment.apiUrl}/api/v2/contratos`;

  constructor(private readonly http: HttpClient, private headersService: HeadersService) {
    this.headersService.includeObject({ fileName: 'contrato.service.ts', url: this.contratosUrl });
  }

  public getAll(): Observable<Array<ContratoResponse>> {
    return this.http
      .get<{ contratos: ContratoResponse[] }>(this.contratosUrl)
      .pipe(map((response) => response?.contratos));
  }

  public getById(id: number, incluiDocumento?: string, flagTrazerBlob?: string) {
    let queryParams = '';
    if (incluiDocumento || flagTrazerBlob) {
      queryParams = `?incluiDocumento=${incluiDocumento ?? ''}&flagTrazerBlob=${flagTrazerBlob ?? ''}`;
    }
    return this.http.get<any>(`${this.contratosUrl}/${id}${queryParams}`);
  }

  //idTipoContrato não é obrigatório para aceitar o contrato de fidelidade, mas é necessário para aceitar outros contratos
  public aceitar(idPublicacao: number, idTipoContrato?: number): Observable<any> {
    const body: { idPublicacao: number; idTipoContrato?: number } = { idPublicacao };
    if (idTipoContrato !== undefined) {
      body.idTipoContrato = idTipoContrato;
    }
    return this.http.put<any>(`${this.contratosUrl}/aceitar`, body);
  }

  public recusar(idPublicacao: number): Observable<any> {
    return this.http.put<any>(`${this.contratosUrl}/recusar`, { idPublicacao: idPublicacao });
  }

  public getPdfById(id: number): Observable<Blob> {
    return this.http.get(`${this.contratosUrl}/tipos/${id}`, { responseType: 'blob' });
  }

  public getVolumes(): Observable<ContratoVolume[]> {
    return this.http
      .get<{ contratoVolumes?: ContratoVolume[] }>(`${this.contratosUrl}/volumes`)
      .pipe(map((response) => (response ? response.contratoVolumes || [] : [])));
  }

  public consultarTermosFidelidade(): Observable<ConsultarTermoFidelidade[]> {
    return this.http
      .get<{ termosDeFidelidade?: ConsultarTermoFidelidade[] }>(`${this.contratosUrl}/termos-de-fidelidade`)
      .pipe(map((response) => (response ? response.termosDeFidelidade || [] : [])));
  }

  public consultarFundoReservaAtivo(): Observable<number> {
    return this.http
      .get<{ possuiContrato: number }>(`${this.contratosUrl}/fundo-reserva`)
      .pipe(map((response) => response.possuiContrato));
  }
}
